/**
 * Source information for purchase tracking
 */
export type SourceInfo = {
  sourceType:
    | "live_baluu"
    | "embedded"
    | "webcomponent"
    /** Checkout mounted on the school's Baluu-hosted website-v2 site. */
    | "websiteV2"
    | "whatsapp";
  url: string | null;
  parentUrl?: string | null;
  referrer?: string | null;
  isIframe: boolean;
  hostname?: string | null;
  // WhatsApp-specific fields
  channel?: string;
  whatsappPhone?: string;
};

/**
 * Source type enumeration for purchase tracking
 */
export const SourceTypes = {
  LIVE_BALUU: "live_baluu",
  EMBEDDED: "embedded",
  WEBCOMPONENT: "webcomponent",
  WHATSAPP: "whatsapp",
} as const;

/**
 * Detects if running inside an iframe
 */
function isInIframe(): boolean {
  try {
    return window.parent !== window;
  } catch {
    // Cross-origin check may throw, assume iframe
    return true;
  }
}

/**
 * Gets the parent URL when in an iframe
 */
function getParentUrl(): string | undefined {
  if (!isInIframe()) {
    return undefined;
  }

  try {
    const referrerUrl = new URL(document.referrer);
    return `${referrerUrl.origin}${referrerUrl.pathname}`;
  } catch {
    return document.referrer || undefined;
  }
}

/**
 * Gets comprehensive source information for webcomponents
 * Webcomponents always report sourceType as "webcomponent"
 */
export function getSourceInfo(): SourceInfo {
  const inIframe = isInIframe();
  const currentUrl = window.location.href;
  const hostname = window.location.hostname;
  const referrer = document.referrer || undefined;
  const parentUrl = getParentUrl();

  return {
    // Webcomponents always identify as webcomponent source type
    sourceType: SourceTypes.WEBCOMPONENT,
    url: currentUrl,
    parentUrl,
    referrer,
    isIframe: inIframe,
    hostname,
  };
}
